import Vue from "vue";
import { Component } from "vue-property-decorator";
import { stringMaxLength } from "../../../../assets/validation/common";
import CurrencyRestModel from "../../../../models/rest/register/currencyRestModel";

@Component
export default class CurrencyDialog extends Vue {
    validation = {
        code: [stringMaxLength(this.$i18n, this.$t("common.code"), 3), (value: string) => !!value || this.$t("common.validationErrorRequired")],
        name: [stringMaxLength(this.$i18n, this.$t("common.name"), 128), (value: string) => !!value || this.$t("common.validationErrorRequired")],
    };

    get showDialog(): boolean {
        return this.$store.direct.state.register.showCurrencyDialog;
    }

    get model(): CurrencyRestModel {
        return this.$store.direct.state.register.currency;
    }

    async saveClick() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (valid) {
            await this.$store.direct.dispatch.register.updateCurrency();
        }
    }

    async backClick() {
        await this.$store.direct.dispatch.register.closeCurrencyDialog();
    }
}
